import { Col, Divider, Row, Typography } from "antd"
import { ApprovedProgressBasedPaymentSummary } from "../../../domain/proposals/paymentSummary"
import PaymentSection from "./PaymentSection"
import { WorkareaGroup } from "../../../domain/workareas/group"
import { centsToDollarsDisplay, percentageDisplayWhole } from "../../displayFormatters"

type Props = {
  summary: ApprovedProgressBasedPaymentSummary
  workareaGroups: WorkareaGroup[]
}

const ProgressBased = ({summary, workareaGroups}: Props) => {
  const groupNames = workareaGroups.filter(x => summary.workareaGroupIds.some(y => y == x.id)).map(x => x.name)
  const total = summary.subtotal + summary.totalSalesTax
  const divider = <Divider style={{margin: '8px 0 8px 0'}}/>
  
  return <PaymentSection title="Progress-based Invoicing Schedule">
    <Row>
      <Col span={24}>Pertains to: <strong>{groupNames.join(', ')}</strong></Col>
    </Row>
    {divider}
    {summary.payments.map((payment, i) => <div key={i}>
      <Row>
        <Col span={12}>{payment.title}</Col>
        <Col span={12} style={{textAlign: 'right'}}>{centsToDollarsDisplay(payment.amount)}</Col>
      </Row>
      <Row>
        <Col span={12}>
          <Typography.Text type="secondary">{payment.note}</Typography.Text>
        </Col>
        <Col span={12} style={{textAlign: 'right'}}>
          <Typography.Text type="secondary">{percentageDisplayWhole(payment.percentage)}</Typography.Text>
        </Col>
      </Row>
      {divider}
    </div>)}
    <Row style={{fontSize: '1.2em', fontWeight: 'bold'}}>
      <Col span={12}>Total</Col>
      <Col span={12} style={{textAlign: 'right'}}>{centsToDollarsDisplay(summary.subtotal)}</Col>
    </Row>
    <Row>
      <Col span={12}></Col>
      <Col span={12} style={{textAlign: 'right'}}>
        {summary.totalSalesTax > 0 && <Typography.Text type="secondary">{centsToDollarsDisplay(total)} with sales tax</Typography.Text>}
      </Col>
    </Row>
  </PaymentSection>
}

export default ProgressBased
